import { HotelFilter } from '@/__generated';
import { cloneDeep, range, sumBy } from 'lodash';
import React from 'react';

interface Props {
  hotelFilter: HotelFilter;
  onChange: (values: number[]) => void;
  selectedValues: number[];
}

const RatingsFilter = ({ hotelFilter, onChange, selectedValues }: Props) => {
  const onCheckboxChange = (star: number) => {
    let values = cloneDeep(selectedValues);
    if (values.includes(star)) {
      values = values.filter(x => x !== star);
    } else {
      values = [...values, star];
    }

    onChange(values);
  };

  let data = React.useMemo(() => {
    let starRatings: any = hotelFilter.starRatings;
    if (starRatings) {
      let stars = Object.keys(starRatings);
      return range(1, 6)
        .reverse()
        .map(star => {
          return {
            star: star,
            count: sumBy(stars, x => {
              let _s = parseInt(x);
              if (_s === star) {
                return starRatings[x] || 0;
              }
            }),
          };
        })
        .filter(x => x.count || selectedValues?.includes(x.star));
    }
    return [];
  }, [hotelFilter, selectedValues]);
  if (!data.length) {
    return null;
  }
  return (
    <div className="sidebar__item">
      <h5 className="text-18 fw-500 mb-10">Star ratings</h5>
      <div className="sidebar-checkbox">
        {data.map(star => (
          <div key={star.star} className="row y-gap-10 items-center justify-between">
            <div className="col-auto">
              <div className="form-checkbox d-flex items-center">
                <input type="checkbox" onClick={() => onCheckboxChange(star.star)} checked={selectedValues?.includes(star.star)} />
                <div className="form-checkbox__mark">
                  <div className="form-checkbox__icon icon-check" />
                </div>
                <div className="text-15 ml-10">
                  {range(0, star.star).map(k => {
                    return <i key={k} className="icon-star text-14 text-yellow-2 mr-4" />;
                  })}
                </div>
              </div>
            </div>
            <div className="col-auto">
              <div className="text-15 text-light-1">{star.count}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RatingsFilter;
